import SignLesseeInterviewEvent from "../../../../src/events/2022/04/sign-lessee-interview/main";
import * as React from 'react';
export default {
  SignLesseeInterviewEvent,
  React
};